// Application version for cache busting
// This file is regenerated on each build with a new timestamp
const VERSION = {
  build: '1.5.6',
  timestamp: 1763480064467
};

export default VERSION;
export const APP_VERSION = `${VERSION.build}-${VERSION.timestamp}`;
